module.exports = __webpack_public_path__ + "img/portfolio-couples-001.4d30dfeb.jpg";